// extracted by mini-css-extract-plugin
module.exports = {"user-line-name":"user-avatar_user-line-name__PvD8Y","user-image":"user-avatar_user-image__gUuzI"};